import { hasNativeIntercom, showMessenger } from 'utilities/intercom';
import { IntercomAPI } from 'react-intercom';
export const navItems = {
    faq: [
        {
            text: 'Om levering',
            href: 'https://hjelp.morgenlevering.no/nb/collections/1082002-levering',
        },
        {
            text: 'Endre en ordre',
            href: 'https://hjelp.morgenlevering.no/nb/articles/3811380-hvordan-endre-kansellere-en-bestilling',
        },
        {
            text: 'Bedrift',
            to: '/bedrift',
        },
        {
            text: 'Hva er fast levering?',
            href: 'https://hjelp.morgenlevering.no/nb/collections/1082020-fast-levering',
        },
    ],
    articles: [
        {
            translate: 'footerFAQLink',
            href: `${process.env.FAQ_URL}`,
        },
        {
            translate: 'footerContactUsLink',
            href: '#',
            onClick: (event) => {
                event.preventDefault();
                // Native intercom not available on Android yet
                if (hasNativeIntercom()) {
                    return showMessenger();
                }
                // Default, use intercom web
                return IntercomAPI('show');
            },
        },
        {
            translate: 'footerAboutUsLink',
            href: `${process.env.ABOUT_US_URL}`,
        },
        {
            translate: 'footerPrivacyLink',
            href: `${process.env.PRIVACY_URL}`,
        },
    ],
    social: [
        {
            text: 'Instagram',
            href: `${process.env.INSTAGRAM_URL}`,
        },
        {
            text: 'Facebook',
            href: `${process.env.FACEBOOK_URL}`,
        },
    ],
};
